import { styled } from "styled-components";
import { Button, Container, Heading, Modal } from "../../global/styles/styles";

const ContainerMenuButton = styled(Container)`
    width: 50vw;
    min-width: 250px;
    justify-content: space-evenly;
`;

const IconMenu = styled.div`
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: absolute;
    right: 15px;
    top: 15px;
`;

const MenuButton = styled(Button)`
    font-size: 18px;
    width: 100%;
    max-width: 400px;
    max-height: 50px;
`;

const ModalContainer = styled.div`
    height: calc(100 * var(--vh));
    width: 100vw;
    background-color: rgba(100, 100, 100, .8);
    position: absolute;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
`;
    
const ModalContent = styled(Modal)`
    flex-direction: column;
    gap: 5px;
`;

const Title = styled(Heading)`
    justify-self: flex-end;
    font-size: 48px; 
    font-weight: 550;
`;

export {
    ContainerMenuButton,
    IconMenu,
    MenuButton,
    ModalContainer,
    ModalContent,
    Title,
};